import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import { InputRules } from "@/rules";
import AffiliationAutocomplete from "@/components/input/AffiliationAutocomplete.vue";
import { useApi } from "@/plugins/api/api";

export type Department = {
  affiliationId?: number;
  amount1?: number;
  amount2?: number;
  amount3?: number;
  subSpecialCommit?: string;
};

type Type = typeof type[number];

type Props = {
  value?: Department;
  userId: number;
  type?: Type;
};
type Emits = {
  (e: "input", value: Department): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDepartmentForm',
  props: {
    value: { default: () => ({ amount1: 0, amount2: 0, amount3: 0 }) },
    userId: null,
    type: { default: "regist" }
  },
  emits: ["input"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (e: "input", value: Department): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: Department, userId: number, type: Type };

const { Paths } = useApi();

const type = ["regist", "edit"] as const;



const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const isEdit = computed(() => props.type === "edit");

const path = computed(() =>
  isEdit.value
    ? undefined
    : `${Paths.userMaster.departments.affiliation}/${props.userId}`
);

const hint = computed(() => (isEdit.value ? "編集不可" : ""));

const vform = ref();

const validate = (): boolean => vform.value?.validate();
const reset = (): void => vform.value?.reset();
const resetValidation = (): void => vform.value?.resetValidation();

expose({
  validate,
  reset,
  resetValidation
});

return { __sfc: true,Paths, type, props, emits, modelValue, isEdit, path, hint, vform, validate, reset, resetValidation, InputRules, AffiliationAutocomplete }
}

})